









































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { refResepStore } from "@/store/modules/ReferensiResep";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";
import ResepRalanUnifiedSvc from "@/services/ResepRalanUnified";
import ResepTerstrukturSvc from "@/services/ResepTerstruktur";
import {
  BarisResepTerstruktur,
  KonteksAptol,
  KonteksBatasJkn,
  ReferensiBaris,
  SIGNA_LAIN,
  angkaTeks,
  hitungJumlah,
  labelSigna,
  masalahBaris,
  masalahAptol,
  masalahJkn,
  pratinjauAturanPakai,
  signaUntukSediaan,
  statusBatasJkn
} from "@/utils/resepTerstruktur";

const URUTAN_FOKUS = [
  "qty",
  "alasanJkn",
  "signa",
  "signaBebas",
  "dosis",
  "satuan",
  "aturan",
  "rute"
];

const LABEL_SUMBER: Record<string, string> = {
  personal: "Isian dari resep Anda sebelumnya",
  institusi: "Isian dari pola resep RS",
  template: "Isian dari template resep",
  profil: "Isian dari profil obat farmasi",
  sediaan: "Isian dari bentuk sediaan"
};

@Component({ components: { ObatSearchBox } })
export default class ObatItemTerstrukturRow extends Vue {
  @Prop({ required: true }) item!: BarisResepTerstruktur;
  @Prop({ required: true }) index!: number;
  @Prop({ default: "" }) depoId!: string;
  @Prop({ type: Boolean, default: false }) tampilkanMasalah!: boolean;
  @Prop({ type: Boolean, default: false }) ringkas!: boolean;
  @Prop({ default: null }) batasJkn!: KonteksBatasJkn | null;
  @Prop({ default: 0 }) terpakaiJknLain!: number;
  @Prop({ default: null }) aptol!: KonteksAptol | null;
  @Prop({ default: null }) registerId!: string | number | null;

  showObatSearch = false;
  durasiPilihan = [3, 5, 7, 14, 30];

  get referensi(): ReferensiBaris {
    return {
      signa: (refResepStore.refFrekuensi || []) as any,
      rute: (refResepStore.refRute || []) as any,
      satuan: refResepStore.refSatuanDosis || [],
      aturan: refResepStore.refAturanTambahan || []
    };
  }

  get opsiSigna() {
    const daftar = signaUntukSediaan(
      this.referensi,
      this.item.sediaan_group,
      this.item.frekuensi_id
    ).map(signa => ({
      value: signa.id,
      teks: labelSigna(signa),
      disabled:
        !!signa.disabled && Number(signa.id) !== Number(this.item.frekuensi_id)
    }));

    return [
      ...daftar,
      { value: SIGNA_LAIN, teks: "Lain-lain (tulis sendiri)", disabled: false }
    ];
  }

  get opsiSatuan() {
    return this.referensi.satuan.filter(
      s =>
        s.tipe === "DOSIS" &&
        (!s.disabled || Number(s.id) === Number(this.item.satuan_dosis_id))
    );
  }

  get opsiAturan() {
    return this.referensi.aturan.filter(
      a => !a.disabled || this.item.aturan_tambahan_ids.includes(Number(a.id))
    );
  }

  get opsiRute() {
    return this.referensi.rute.filter(
      r => !r.disabled || Number(r.id) === Number(this.item.rute_id)
    );
  }

  get pilihanSigna() {
    return this.item._signa_lain ? SIGNA_LAIN : this.item.frekuensi_id;
  }

  set pilihanSigna(nilai: any) {
    if (nilai === SIGNA_LAIN) {
      this.item._signa_lain = true;
      this.item.frekuensi_id = null;
      this.$nextTick(() => this.fokus("signaBebas"));
    } else {
      this.item._signa_lain = false;
      this.item.signa_bebas = null;
      this.item.frekuensi_id = nilai ?? null;
    }
    this.hitungUlang();
  }

  get pratinjau() {
    return pratinjauAturanPakai(this.item, this.referensi);
  }

  get statusJkn() {
    return statusBatasJkn(this.item, this.batasJkn, this.terpakaiJknLain);
  }

  get masalahJknBaris() {
    return masalahJkn(this.item, this.statusJkn, this.batasJkn);
  }

  get masalahAptolBaris() {
    return masalahAptol(this.item, this.aptol);
  }

  get masalah() {
    return (
      masalahBaris(this.item) || this.masalahJknBaris || this.masalahAptolBaris
    );
  }

  @Watch("item.obat_id")
  @Watch("item._is_obat_kronis")
  @Watch("aptol")
  async cekAptol(): Promise<void> {
    const item = this.item;
    const obatId = item.obat_id;
    if (
      !obatId ||
      !item._is_obat_kronis ||
      !this.registerId ||
      !this.aptol ||
      !this.aptol.aktif
    ) {
      if (!item._is_obat_kronis) {
        item._aptol = null;
      }
      return;
    }
    const hasil = await ResepTerstrukturSvc.aptol(this.registerId, obatId);
    if (item.obat_id !== obatId) {
      return;
    }
    item._aptol = hasil && hasil.cek ? hasil.cek : null;
  }

  angka(nilai: number) {
    return angkaTeks(nilai);
  }

  pakaiBatasJkn() {
    if (!this.statusJkn) return;
    this.item.qty = this.statusJkn.sisa;
    this.item._auto_qty = false;
  }

  isiJumlahJkn() {
    const status = this.statusJkn;
    if (!status || status.sisa <= 0) return;
    const qty = Number(this.item.qty);
    if (!this.item.qty || !isFinite(qty) || qty <= 0) {
      this.item.qty = status.sisa;
      this.item._auto_qty = true;
    } else if (this.item._auto_qty && qty > status.sisa) {
      this.item.qty = status.sisa;
    }
  }

  get sumberLabel() {
    if (this.item._disalin) {
      return this.item._disalin;
    }
    return this.item._sumber ? LABEL_SUMBER[this.item._sumber] || "" : "";
  }

  get rowClass() {
    if (!this.item.obat_id) return "row-empty";
    return this.masalah ? "row-invalid" : "row-ok";
  }

  mounted() {
    if (this.item.obat_id && !this.item._sumber) {
      this.muatIsianAwal(this.item.id === null);
    }
    if (this.item._fokus) {
      this.item._fokus = false;
      this.$nextTick(() => this.fokus("qty"));
    }
  }

  @Watch("item.obat_id")
  gantiObatId(baru: string, lama: string) {
    if (baru && lama && baru !== lama) {
      this.muatIsianAwal(true);
    }
  }

  fokus(ref: string) {
    const target = this.$refs[ref] as any;
    if (target && typeof target.focus === "function") {
      target.focus();
      return true;
    }
    return false;
  }

  pindahFokus(event: KeyboardEvent) {
    const sumber = event.target as Node;
    const urutan = URUTAN_FOKUS.filter(ref => !!this.$refs[ref]);
    const posisi = urutan.findIndex(ref => {
      const komponen = this.$refs[ref] as any;
      return komponen && komponen.$el && komponen.$el.contains(sumber);
    });

    if (posisi < 0) {
      return;
    }

    event.preventDefault();

    this.$nextTick(() => {
      const berikut = urutan[posisi + 1];
      if (!berikut || !this.fokus(berikut)) {
        this.$emit("selesai-baris", this.index);
      }
    });
  }

  async muatIsianAwal(isiKolom: boolean) {
    const obatId = this.item.obat_id;
    if (!obatId) return;
    try {
      const d = await ResepRalanUnifiedSvc.obatDefaults(obatId);
      const item = this.item;

      if (item.obat_id !== obatId) {
        return;
      }

      item._sumber = d.source && d.source !== "none" ? d.source : null;
      item._is_high_alert = !!d.is_high_alert;
      item._is_lasa = !!d.is_lasa;
      item._is_obat_kronis = !!d.is_obat_kronis;
      item._maks_jkn = d.resep_max_value ?? null;
      item._restriksi = d.restriksi ?? null;
      item.sediaan_group = d.sediaan_group ?? item.sediaan_group;

      if (!isiKolom) {
        return;
      }

      if (!item.rute_id && d.rute_id) item.rute_id = d.rute_id;
      if (!item.frekuensi_id && !item._signa_lain && d.frekuensi_id) {
        item.frekuensi_id = d.frekuensi_id;
      }
      if ((item.dosis_qty === null || item.dosis_qty === "") && d.dosis_qty) {
        item.dosis_qty = d.dosis_qty;
      }
      if (!item.satuan_dosis_id && d.satuan_dosis_id) {
        item.satuan_dosis_id = d.satuan_dosis_id;
      }
      if (
        item.aturan_tambahan_ids.length === 0 &&
        d.aturan_tambahan_ids &&
        d.aturan_tambahan_ids.length
      ) {
        item.aturan_tambahan_ids = [...d.aturan_tambahan_ids];
      }
      if (!item.qty && d.qty) {
        item.qty = d.qty;
        item._auto_qty = true;
      }
      if (!item._durasi_hari && d.durasi_hari) {
        item._durasi_hari = d.durasi_hari;
      }
      this.hitungUlang();
      this.isiJumlahJkn();
    } catch (e) {
      this.item._sumber = null;
    }
  }

  setDurasi(hari: number) {
    this.item._durasi_hari = this.item._durasi_hari === hari ? null : hari;
    if (this.item._durasi_hari) {
      this.item._auto_qty = true;
    }
    this.hitungUlang();
  }

  hitungUlang() {
    if (!this.item._auto_qty && this.item.qty) {
      return;
    }
    const jumlah = hitungJumlah(this.item, this.referensi);
    if (jumlah && jumlah > 0) {
      const status = this.statusJkn;
      this.item.qty =
        status && status.sisa > 0 ? Math.min(jumlah, status.sisa) : jumlah;
      this.item._auto_qty = true;
    }
  }

  gantiObat(obat: any) {
    const item = this.item;
    item.obat_nama = obat.nama;
    item.harga = obat.harga;
    item.qty_unit = obat.satuan;
    item.qty = null;
    item.frekuensi_id = null;
    item.rute_id = null;
    item.dosis_qty = null;
    item.satuan_dosis_id = null;
    item.signa_bebas = null;
    item.aturan_tambahan_ids = [];
    item.sediaan_group = null;
    item._signa_lain = false;
    item._auto_qty = false;
    item._durasi_hari = null;
    item._dosis_lama = null;
    item._disalin = null;
    item._sumber = null;
    item._is_high_alert = false;
    item._is_lasa = false;
    item._is_obat_kronis = false;
    item._maks_jkn = null;
    item._restriksi = null;
    item.alasan_melebihi_jkn = null;
    item.alasan_aptol = null;
    item._aptol = null;
    item.obat_id = obat.id;
    this.showObatSearch = false;
  }
}
